// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__FydZB","tab":"ProcedureTabs_tab__3xFHd"};